import {Portal, Content} from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';

import type {DropdownMenuContentProps} from '@radix-ui/react-dropdown-menu';

export function DropdownContent({
  ref: forwardedRef,
  children,
  className,
  ...props
}: DropdownMenuContentProps &
  React.RefAttributes<HTMLDivElement>): React.JSX.Element {
  return (
    <Portal>
      <Content
        sideOffset={5}
        {...props}
        ref={forwardedRef}
        className={clsx(
          className,
          'max-h-radix-dropdown-menu-content-available max-w-radix-dropdown-menu-content-available divide-y divide-slate6 overflow-y-auto rounded-md bg-slate1 py-1 shadow-lg outline-1! -outline-offset-1 outline-slate6! radix-side-bottom:animate-slide-up-and-fade radix-side-left:animate-slide-right-and-fade radix-side-right:animate-slide-left-and-fade radix-side-top:animate-slide-down-and-fade'
        )}
      >
        {children}
      </Content>
    </Portal>
  );
}
